<ul>
  @for (breadcrumb of breadcrumbs(); track breadcrumb.label; let last = $last) {
    <li [class]="{ 'breadcrumb-item': true, 'hyperlink': isClickable(breadcrumb), 'last': last }" (click)="handleClick(breadcrumb)">
      <fw-ellipsis class="breadcrumb-text" [text]="breadcrumb.label" [showTooltipOnlyEllipsized]="true"></fw-ellipsis>
    </li>
    @if (!last) {
      <li class="breadcrumb-separator">
        <fw-icon size="medium" color="slate">chevron-forward</fw-icon>
      </li>
    }
  }
</ul>
